import { asyncQueue } from 'utils/utils'
import { useToastContext } from './useToastContext'

export type SubmitQueueArgs<PayloadType, ResponseType> = {
  payloadArray: PayloadType[]
  service: (data: PayloadType) => Promise<ResponseType>
  successToastMessage?: string
  errorToastMessage?: string
}

export const useSubmitQueue = () => {
  const addToast = useToastContext()

  const successToast = (message: string) => addToast({ title: message, state: 'success', delay: 5 })
  const errorToast = (message: string) => addToast({ title: message, state: 'error', delay: 5 })

  const submitQueue = <PayloadType, ResponseType>({
    payloadArray,
    service,
    successToastMessage,
    errorToastMessage,
  }: SubmitQueueArgs<PayloadType, ResponseType>): Promise<PayloadType[]> => {
    return asyncQueue(
      payloadArray,
      service,
      () => successToastMessage && successToast(successToastMessage),
      () => errorToastMessage && errorToast(errorToastMessage)
    )
  }

  return { submitQueue }
}
